import React, { useState } from "react";
import "../../Style/Project-page.css";
// import project1 from "../../Assets/fooddost-mockup-desktop.png"
// import project2 from "../../Assets/fooddostmockup-phone.png"
import video from "../../Assets/video.mp4";
import invoice from "../../Assets/invoice.mp4";
import compressor from "../../Assets/compressor.mp4";
import noteApp from "../../Assets/note-web.mp4";
import vantattva from "../../Assets/vantattva.mp4";
import siddhco from "../../Assets/siddhco.mp4";
import twentenyfour from "../../Assets/24Appp.mp4";
// import twentenyfour from "../24app.mp4";
// const ProjectData = [
//     {
//         "id": 1,
//         "img": project1,
//         "img2": project2,
//         "Discription": "FoodDost: Delicious meals delivered to your doorstep. Explore, order, and enjoy a variety of cuisines. Let FoodDost satisfy your cravings!",
//         "Technology": "HTML ,React ,JavaScript ,CSS ,Tailwind ,ExpressJS ,NodeJS ,MongoDB",
//         "Duration": "An Individual Project executed in 7 days",
//         "Github": "https://github.com/piyush2205/FoodDost",
//         "Demo": "https://food-dost.vercel.app/",
//     },

// ]

const Project = () => {
  const [activeFilter, setActiveFilter] = useState("All");

  const filterCategories = [
    { id: 1, name: "All" },
    { id: 2, name: "React" },
    { id: 3, name: "WordPress" },
    { id: 4, name: "Shopify" },
    { id: 5, name: "Native" },
  ];
  // const [hovered, setHovered] = useState(false);
  // const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  // const handleMouseEnter = () => {
  //     setHovered(true);
  // };

  // const handleMouseLeave = () => {
  //     setHovered(false);
  // };
  // const handleMouseMove = (e) => {
  //     const { offsetX, offsetY } = e.nativeEvent; // Get the mouse position relative to the container
  //     setMousePosition({ x: offsetX, y: offsetY });
  // };

  const handleClick_main = () => {
    // window.location.href = 'https://food-dost.vercel.app/';

    window.open("https://note-app-web-five.vercel.app/", "_blank");
  };

  const handleClick_1 = () => {
    // window.location.href = 'https://food-dost.vercel.app/';
    window.open("https://invoice-genrator-ruby.vercel.app/", "_blank"); // Replace with your desired URL
  };

  const handleClick_2 = () => {
    window.open("https://image-compressor-blue-six.vercel.app/", "_blank");
  };

  const handleClick_3 = () => {
    window.open("https://food-dost.vercel.app/", "_blank"); // Replace with your desired URL
  };

  const handleClick_4 = () => {
    // window.location.href = 'https://food-dost.vercel.app/';
    window.open("https://bayarscoffee.com/", "_blank"); // Replace with your desired URL
  };

  const handleClick_5 = () => {
    window.open("https://siddhco.com/", "_blank");
  };

  const handleClick_6 = () => {
    window.open("https://vantattva.com/", "_blank"); // Replace with your desired URL
  };

  const handleClick_7 = () => {
    window.open(" https://react-template-html.vercel.app/", "_blank"); // Replace with your desired URL
  };
 

  const projects = [
    {
      id: 1,
      title: "Invoice Generator",
      description: "Generate professional invoices with customizable templates",
      category: "React",
    //   tooltip_description: [
    //     "Built with Electron.js for cross-platform compatibility",
    //     "Features rich text editing and file management",
    //     "Implements local storage for offline access",
    //   ],
      video: invoice,
      tech: ["React/Vite", "HTML", "CSS", "JavaScript"],
      onClick: handleClick_1,
    },
    {
      id: 2,
      title: "File Compressor",
      description: "Compress files efficiently",
      category: "React",
      video: compressor,
      tech: ["React", "HTML", "JavaScript"],
      onClick: handleClick_2,
    },
    {
      id: 3,
      title: "Food Dost",
      description: "A full-featured Food application",
      category: "React",
      video: video,
      tech: ["React/Vite", "HTML", "CSS", "JavaScript"],
      onClick: handleClick_3,
    },
    
    // {
    //   id: 4,
    //   title: "Bayars-Coffee",
    //   description: "Coffee Website",
    //   category: "WordPress",
    //   video: video,
    //   tech: ['WordPress', 'HTML', 'CSS', 'JavaScript'],
    //   onClick: handleClick_4,
    // },
    {
        id: 5,
        title: "Siddhco",
        description: "Siddhco Website",
        category: "WordPress",
        video: siddhco,
        tech: ['WordPress', 'HTML', 'CSS', 'JavaScript'],
        onClick: handleClick_5,
      },
      
    {
        id: 6,
        title: "Vantattva",
        description: "Vanattva honey website",
        category: "Shopify",
        video: vantattva  ,
        tech: ['Shopify', 'HTML', 'CSS', 'JavaScript'],
        onClick: handleClick_6,
      },
      {
        id: 7,
        title: "24/7 App",
        description: "24/7 App",
        category: "Native",
        video: twentenyfour ,
        tech: ['Native', 'HTML', 'CSS', 'JavaScript'],
        onClick: handleClick_7,
      }
  ];

 
  const filteredProjects =
    activeFilter === "All"
      ? projects
      : projects.filter((project) => project.category === activeFilter);
  return (
    <>
      {/* <svg style={{ display: "none" }}>
                <filter id='noiseFilter'>
                    <feTurbulence
                        // type='fractalNoise'
                        baseFrequency='9.6'
                        stitchTiles='stitch'
                    />
                </filter>
            </svg> */}
      <section id="Project" data-scroll-section>
        <div className="Projects">
          <div className="project-h1-div">
            <h1 className="Project-h1">Projects </h1>
          </div>
          {/* Filter Capsules */}
          <div className="filter-container">
            {filterCategories.map((category) => (
              <button
                key={category.id}
                className={`filter-capsule ${
                  activeFilter === category.name ? "active" : ""
                }`}
                onClick={() => setActiveFilter(category.name)}
              >
                {category.name}
              </button>
            ))}
          </div>
          {/* ........................................................... */}
          <div className="grainy">
            {/* <div
              className="project-container"
              onClick={handleClick_main}
              style={{
                cursor: "pointer",
              }}
            >
              <div className="project-card">
                <slot name="media">
                  <video
                    src={noteApp}
                    autoPlay
                    muted
                    loop
                    className="video"
                  ></video>
                </slot>
              </div>
              <div className='div-circle-hover'
                                style={{
                                    opacity: hovered ? 1 : 0,
                                    // transform: hovered ? 'translate(-50%, -50%) scale(1)' : 'scale(0.8)',
                                    // transition: 'opacity 0.5s, transform 0.5s',
                                    left: mousePosition.x + 250,
                                    top: mousePosition.y - 100,
                                    transition: 'opacity 0.3s ease, transform 0.3s ease',
                                }}>
                                Play
                            </div>
              <div className="project-card-div">
                <div className="project-card-div-button-1">React/Vite</div>
                <div className="project-card-div-button-2">
                  HTML . Css . JavaScript . TypeScript . Electron.js
                </div>
              </div>

              <div className="project-card-div-2">
                <h1 className="project-div-2-h1">Note App</h1>
                <p className="project-div-2-h2">
                  Desktop App Development . Logic Building
                </p>
              </div>
            </div> */}

            {/* ................................................................................ */}

            <div className="Project-container-gird-project-page">
              {filteredProjects.map((project) => (
                <div
                  className="project-container-2-project-page"
                  key={project.id}
                >
                  <div
                    className="project-card-2-project-page"
                    onClick={project.onClick}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <slot name="media">
                      <video
                        src={project.video}
                        alt={project.title}
                        autoPlay
                        muted
                        loop
                        playsInline
                        className="video-project-page"
                      ></video>
                      {/* <image href={ino} /> */}
                    </slot>
                  </div>
                  <div className="project-card-div-project-page">
                    <div className="project-card-div-button-1-project-page">
                      {project.tech[0]}
                    </div>
                    <div className="project-card-div-button-2-project-page">
                      {project.tech[1]} . {project.tech[2]} . {project.tech[3]}{" "}
                      . {project.tech[4]}
                    </div>
                  </div>

                  <div className="project-card-div-2-project-page">
                    <h1 className="project-div-2-h1-project-page">
                      {project.title}
                    </h1>
                    <p className="project-div-2-h2-project-page">
                      {project.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* ...................................................................................................... */}
            {/* .................................................................................................. */}

            <div />
          </div>
        </div>
      </section>
    </>
  );
};

export default Project;
